export const h5TopicType = [
  {
    name: '样式1',
    value: 'H5HorizontalImageWall',
  },
  {
    name: '样式2',
    value: 'H5VerticalImageWall',
  },
]
export const h5NewsImageType = [
  {
    name: '横向',
    value: 'H5HorizontalNewsImageList',
  },
  {
    name: '纵向',
    value: 'H5VerticalNewsImageList',
  },
]
export const h5NewsVideoType = [
  {
    name: '横向',
    value: 'H5HorizontalNewsVideoList',
  },
  {
    name: '纵向',
    value: 'H5VerticalNewsVideoList',
  },
]

export default [
  {
    name: '导航栏',
    code: 'E0011',
    config: {
      componentName: 'AppNavigation',
      configName: 'AppNavigationBarConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 50,
    },
  },
  {
    name: '列表',
    code: 'E0012',
    config: {
      componentName: 'AppList',
      configName: 'AppListConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 400,
    },
  },
  {
    name: '专题',
    code: 'E0012',
    config: {
      componentName: 'H5HorizontalImageWall',
      configName: 'H5TopicConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 400,
      type: 3,
    },
  },
  {
    name: 'banner',
    code: 'E0015',
    config: {
      componentName: 'H5BannerLong',
      configName: 'H5BannerConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 200,
      type: 0,
    },
  },
  {
    name: '图片列表',
    code: 'E0016',
    config: {
      componentName: 'H5HorizontalNewsImageList',
      configName: 'H5NewsImageConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 400,
      type: 2,
    },
  },
  {
    name: '视频列表',
    code: 'E0017',
    config: {
      componentName: 'H5HorizontalNewsVideoList',
      configName: 'H5NewsVideoConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 400,
      type: 3,
    },
  },
  {
    name: '轮播图',
    code: 'E0013',
    config: {
      componentName: 'AppCarousel',
      configName: 'AppCarouselConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 240,
      type: 2,
    },
  },
  {
    name: '下拉加载',
    code: 'E0014',
    config: {
      componentName: 'AppLoadMore',
      configName: 'AppLoadMoreConfig',
      isDraggable: true,
      isResizable: true,
      w: 375,
      h: 400,
    },
  },
]
